import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row } from 'antd';
import Link from 'redux-first-router-link';
import { isWordCupStarted } from '@selectors/clock';
import Announcement from '@views/Announcement';
import Countdown from '@views/Countdown';
import config from '@config';

import './Home.css';

export const StatsItemsOld = ({ score, ranking }) => {
  return (
    <div className="stats-container">
      <div className="header-item header-item-score">
        <img src={`${config.basePath}/img/coins.svg`} alt="" />
        <div>
          <h3>Puntaje</h3>
          <h2 className="value">{score}</h2>
        </div>
      </div>
      <div className="header-item header-item-ranking">
        <img src={`${config.basePath}/img/copa.svg`} alt="" />
        <div>
          <h3>Ranking general</h3>
          <h2 className="value">{ranking ? `#${ranking}` : '# -'}</h2>
        </div>
      </div>
    </div>
  );
};

/**
 * Vista inicial: saludo y CTA en home-cta; stats solo cuando ya comenzó el mundial.
 */
export const Home = ({
  isReady,
  userId,
  username,
  score,
  ranking,
  worldCupStarted,
  worldCupStartDate,
}) => {
  return (
    <div className="home">
      <Announcement />
      <div className="hero-bg">
        <h1>¡Hola {username}!</h1>
        <p className="home-subtitle">
          Bienvenido al prode del Mundial de Fútbol 2026, un juego de Página|12 para predecir los resultados del mundial.
        </p>
        {!worldCupStarted ? (
          <p>
            <b>¡Completá tu pronóstico antes de que empiece! </b>
          </p>
        ) : null}
        {/* <Prize /> */}
        {!worldCupStarted ? (
          <Row justify="center" className="countdown-container">
            <Countdown date={worldCupStartDate} />
          </Row>
        ) : null}
        {worldCupStarted ? (
          <div className="home-hero-stats">
            <StatsItemsOld ranking={ranking} score={score} />
          </div>
        ) : null}
      </div>
      <div className="home-cta">
        {worldCupStarted ? <StatsItemsOld ranking={ranking} score={score} /> : null}
        <div className="home-cta__cards">
          <article className="home-cta-card">
            <h2 className="home-cta-card__title">Tu Pronóstico</h2>
            <p className="home-cta-card__text">
              Completá tus pronósticos para cada partido del Mundial y competí por grandes premios. Armá tu <b>"Mundial Ideal"</b>, sumá puntos en cada encuentro y escalá posiciones en el ranking general.
            </p>
            <Link to={['mi-mundialito']}>
              <button type="button" className="home-cta-card__btn">
                Ir a mi pronóstico
              </button>
            </Link>
          </article>
          <article className="home-cta-card">
            <h2 className="home-cta-card__title">Mis Torneos</h2>
            <p className="home-cta-card__text">
              ¿Querés jugar con tus amigos? En <b>Torneos de amigos</b>, creá todos los grupos que quieras e invitá a tus amigos a participar. Todos los puntos que ganen sumen a puntaje general. ¡Más chances de ganar!
            </p>
            <Link to={['mis-torneos']}>
              <button type="button" className="home-cta-card__btn">
                Ir a mis torneos
              </button>
            </Link>
          </article>
        </div>
      </div>
    </div>
  );
};

Home.displayName = 'Home';
Home.propTypes = {
  isReady: PropTypes.bool,
  userId: PropTypes.string,
  username: PropTypes.string,
  score: PropTypes.number,
  ranking: PropTypes.number,
  worldCupStarted: PropTypes.bool,
  worldCupStartDate: PropTypes.string,
};
Home.defaultProps = {
  isReady: false,
  userId: null,
  username: '',
  score: 0,
  ranking: 0,
  worldCupStarted: false,
  worldCupStartDate: '',
};

export const mapStateToProps = (state) => ({
  isReady: !!state.user && !state.loading,
  userId: state.user?._id || null,
  username: state.user?.username,
  score: state.user?.score,
  ranking: state.user?.rank,
  worldCupStarted: isWordCupStarted(state),
  worldCupStartDate: state.config.wordcupStartedDateUTC,
});

export default connect(mapStateToProps)(Home);
